<app-navigation-header title="Add Company" i18n-title="@@addCompanyMainTab-addComanyTitle" svgName="sl-add">
	<div class="mat-stepper-navigator">
		@if (stepperRef.selectedIndex === 0) {
			<button
				mat-button
				(click)="movePrevious(stepperRef)"
				class="secondary-stepper-button"
				i18n="@@addCompanyMainTab-backButton"
				data-automation-id="add-company-back-button"
			>
				Back
			</button>
		}
		@if (stepperRef.selectedIndex === 0) {
			<button
				mat-flat-button
				[disabled]="!isValid(stepperRef) || serverCallInProgress"
				(click)="moveNext(stepperRef)"
				class="primary-stepper-button"
				i18n="@@addCompanyMainTab-continueButton"
				data-automation-id="add-company-continue-button"
			>
				Continue
			</button>
		}
	</div>
	<mat-horizontal-stepper linear #stepperRef>
		<ng-template matStepperIcon="edit">
			<mat-icon>check</mat-icon>
		</ng-template>
		<mat-step>
			<ng-template matStepLabel i18n="@@addCompanyMainTab-About">About</ng-template>
			<app-add-company-about [editCompany]="editCompany" [companyType]="companyType"> </app-add-company-about>
		</mat-step>

		<mat-step>
			<ng-template matStepLabel i18n="@@addCompanyMainTab-Confirmation">Confirmation</ng-template>
			<app-add-company-confirmation
				[companyName]="editCompany.company.name"
				[email]="editCompany.adminUser.user.email"
				[addCompanyRequestStatusEvents]="addCompanyRequestStatusEvents"
				[confirmationType]="confirmationType"
			>
			</app-add-company-confirmation>
		</mat-step>
	</mat-horizontal-stepper>
</app-navigation-header>
